import axios from "axios";
import { supabase } from "./supabaseClient";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function authHeader() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Generates any due notifications (server-side, idempotent) and returns the list.
// Saved-event reminders need the client's localStorage saved ids, so we pass them.
export async function syncNotifications(savedIds = []) {
  const headers = await authHeader();
  const { data } = await axios.post(
    `${API}/notifications/sync`,
    { saved_ids: savedIds },
    { headers }
  );
  return data;
}

export async function markNotificationsRead() {
  const headers = await authHeader();
  const { data } = await axios.post(`${API}/notifications/read`, {}, { headers });
  return data;
}

export async function clearNotifications() {
  const headers = await authHeader();
  const { data } = await axios.post(`${API}/notifications/clear`, {}, { headers });
  return data;
}
